import type { ContractSchema } from '@libs/data-access/entities'
import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../../types'
import type { FetchContractsOptions } from '../contract.contract.api'
import { fetchContracts } from '../contract.contract.api'
import { contractQueryKeys } from '../contract.contract.cacheKeys'

export const useFetchAll = (
  request: FetchContractsOptions,
  queryOptions?: UseAppQueryOptions<ContractSchema[]>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: contractQueryKeys.contracts(),
    queryFn: () => fetchContracts(request)
  })
}
